import React from 'react';
import { routes } from 'constants/config';
import useFetch from 'components/shared/hooks/useFetch';
import { Spinner } from 'ui';
import ModuleLoadFailure from './ModuleLoadFailure';

const STATUSES = {
  GRADE_PENDING: 'grade_pending',
  OVERDUE: 'overdue',
  INCOMPLETE: 'incomplete',
  COMPLETED: 'completed',
  AWAITING_REASSIGNMENT: 'awaiting_reassignment',
};

const AssignmentSummary = ({ lessonIdString, currentGroupId, lessonTitle }) => {
  const { data, loading, error, runRequest } = useFetch(
    routes.LESSON_OVERVIEW.ASSIGNMENT_SUMMARY(lessonIdString, currentGroupId),
  );
  if (loading) return <Spinner />;
  if (error) {
    return <ModuleLoadFailure reload={runRequest} />;
  }
  const { statusCounts, canGrade, canViewIndex } = data;
  const statusCountKeys = Object.keys(statusCounts);
  const maxStatusValue = Math.max(...Object.values(statusCounts));
  const showStatusLink = status => {
    if (status === STATUSES.GRADE_PENDING) return canGrade;
    return canViewIndex;
  };
  const getStatusWidth = status => {
    if (maxStatusValue === 0) return 0;
    return (statusCounts[status] * 100) / maxStatusValue;
  };

  const statusLink = status => {
    if (status === STATUSES.GRADE_PENDING) {
      return routes.GRADES.INDEX_V2(lessonIdString, 'lesson');
    }

    return routes.LESSON_OVERVIEW.ASSIGNMENT_STATUS(
      lessonIdString,
      status,
      currentGroupId,
    );
  };

  const statusLabelClass = statusCountKeys.includes(
    STATUSES.AWAITING_REASSIGNMENT,
  )
    ? 'AssignmentSummary-label-extended'
    : 'AssignmentSummary-label';
  return (
    <ul className="AssignmentSummary-statuses Module Module--bordered">
      {statusCountKeys.map(status => (
        <li
          key={status}
          className={`AssignmentSummary-status AssignmentSummary-status--${status}`}
        >
          {showStatusLink(status) && (
            <a className={statusLabelClass} href={statusLink(status)}>
              {t(`assignments.${status}.label`)}
            </a>
          )}
          {!showStatusLink(status) && (
            <span className="AssignmentSummary-label">
              {t(`assignments.${status}.label`)}
            </span>
          )}
          <span className="AssignmentSummary-meterContainer">
            <span
              className="AssignmentSummary-meter"
              style={{ width: getStatusWidth(status) + '%' }}
            />
            <span className="AssignmentSummary-count">
              {statusCounts[status]}
            </span>
          </span>
          {showStatusLink(status) && (
            <a href={statusLink(status)} className="AssignmentSummary-action">
              {t('common.view_all')}
            </a>
          )}
          {!showStatusLink(status) && (
            <span className="AssignmentSummary-action" />
          )}
        </li>
      ))}
    </ul>
  );
};

export default props => <AssignmentSummary {...props} />;
